import React, { useEffect, useState } from "react";
import { resetErrorLog, deleteErrorLog, fetchErrorLog } from "utils/apiService";
import Loader from "components/Loader/Loader";
import { Button, Col, Collapse, Dropdown, Empty, Icon, Input, Menu, message, Row, Typography } from "antd";
import "./error-log.scss";
const { Text } = Typography;
const { Panel } = Collapse;

const ErrorLogTable = (props) => {
    return (
        <div>
            <div className='row'>
                <ListHeader />
            </div>

            <div className='row' style={{ background: "#ffffff" }}>
                {props.errorList?.length > 0 ? (
                    <Collapse
                        bordered={false}
                        showArrow={false}
                        style={{ background: "#FAFAFA" }}
                        className='error-log-panel-icon'
                        expandIcon={({ isActive }) => (
                            <Icon style={{ paddingTop: "6px" }} type='caret-right' rotate={isActive ? 90 : 0} />
                        )}>
                        {props.errorList?.map((item) => {
                            return (
                                <Panel
                                    key={item.uuid}
                                    header={<ErrorLogHeader item={item} FetchErrorLogAPI={props.FetchErrorLogAPI} />}
                                    style={{
                                        background: "#ffffff",
                                        // border:"1px solid #fec708",
                                        marginTop: "8px",
                                        overflow: "hidden",
                                        paddingTop: "16px",
                                        borderRadius: "5px",
                                        boxShadow: "0px 5px 10px rgba(24, 24, 24, 0.05)",
                                    }}>
                                    <Row style={{ padding: "16px 56px", background: "#EBF4ED", height: "76px" }}>
                                        <Col span={7}>
                                            <Text style={{ fontSize: "12px", fontWeight: 400 }}>First Error Time</Text>
                                            <br />
                                            <Text style={{ color: "#464646", fontWeight: 500 }}>
                                                {item.date_created}
                                            </Text>
                                        </Col>
                                        <Col span={5}>
                                            <Text style={{ fontSize: "12px", fontWeight: 400 }}>Occurences</Text>
                                            <br />
                                            <Text style={{ color: "#464646", fontWeight: 500 }}>
                                                {item.occurrences}
                                            </Text>
                                        </Col>
                                        <Col span={5}>
                                            <Text style={{ fontSize: "12px", fontWeight: 400 }}>Reset Count</Text>
                                            <br />
                                            <Text style={{ color: "#464646", fontWeight: 500 }}>
                                                {item.reset_count}
                                            </Text>
                                        </Col>
                                        <Col span={5}>
                                            <Text style={{ fontSize: "12px", fontWeight: 400 }}>Last Reset</Text>
                                            <br />
                                            <Text style={{ color: "#464646", fontWeight: 500 }}>{item.last_reset}</Text>
                                        </Col>
                                    </Row>
                                </Panel>
                            );
                        })}
                    </Collapse>
                ) : (
                    <Empty style={{ padding: "30px" }} image={Empty.PRESENTED_IMAGE_SIMPLE} description='No data' />
                )}
            </div>
        </div>
    );
};

const ErrorLogHeader = ({ item, FetchErrorLogAPI }) => {
    const [errormessageFlag, setErrormessageFlag] = useState(false);
    return (
        <Row
            style={{
                width: "100%",
                align: "center",
                fontWeight: 400,
                padding: "0px 0px 16px 13px",
                // padding: "16px 21px",
                // marginTop:"-20px"
            }}>
            <Col span={5}>
                <Text
                    style={{
                        fontSize: "14px",
                        color: "#181818",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}>
                    {item.api_name}
                </Text>
            </Col>
            <Col span={12}>
                <div
                    style={{
                        whitespace: "nowrap",
                        textAlign: "left",
                        width: "90%",
                        paddingLeft: "5px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}>
                    {/* <Text style={{ color: "464646" ,maxWidth:"100%" , textOverflow:"ellipsis"}}>{item.error_message}</Text> */}
                    {/* <Text style={{ color: "464646" }}>
                        { true ? (
                        (errormessageFlag ? item.error_message : item.error_message?.substring(0, 100))
                        {<span
                            style={{ color: "#fec708", fontWeight: "600" }}
                            onClick={() => setErrormessageFlag(!errormessageFlag)}>
                            {" "}
                            <Icon
                                theme='outlined'
                                type={errormessageFlag ? "up":"down"}
                                style={{ marginTop:"5px" ,strokeWidth: "25" , stroke:"#fec708" , fontSize: '10px' }}
                            />
                            {" "}
                            {errormessageFlag ? "less" : "more"}
                        </span>} ): item.error_message}
                    </Text> */}
                    {item.error_message.length > 100 ? (
                        <Text style={{ color: "464646" }}>
                            {errormessageFlag ? item.error_message : item.error_message?.substring(0, 100) + "..."} {" "}
                            <span
                                style={{ color: "#fec708", fontWeight: "600", display: "inline-block" }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setErrormessageFlag(!errormessageFlag)}}>
                                {" "}
                                <Icon
                                    theme='outlined'
                                    type={errormessageFlag ? "up" : "down"}
                                    style={{ marginTop: "5px", strokeWidth: "25", stroke: "#fec708", fontSize: "10px" }}
                                />{" "}
                                {errormessageFlag ? "less" : "more"}
                            </span>
                        </Text>
                    ) : (
                        <Text style={{ color: "464646" }}>{item.error_message}</Text>
                    )}
                </div>
            </Col>
            <Col span={6}>
                <Text style={{ color: "#747474", paddingLeft: "30px" }}>{item.last_error_time}</Text>
            </Col>
            <Col span={1}>
                <Dropdown
                    placement={"bottomLeft"}
                    overlay={
                        <Menu>
                            <Menu.Item
                                onClick={(e) => {
                                    resetErrorLog({
                                        requestData: {
                                            error_logs: [item.uuid],
                                        },
                                        resCallback: () => {},
                                        res200Callback: (res) => {
                                            message.success("Error log is Successfully Reseted");
                                            FetchErrorLogAPI();
                                        },
                                    });
                                }}>
                                <Text style={{ color: "#181818" }}>Reset</Text>
                            </Menu.Item>
                            <Menu.Item
                                onClick={() => {
                                    deleteErrorLog({
                                        requestData: {
                                            error_logs: [item.uuid],
                                        },
                                        resCallback: () => {},
                                        res200Callback: (res) => {
                                            message.success("Error log is Successfully Deleted");
                                            FetchErrorLogAPI();
                                        },
                                    });
                                }}>
                                <Text
                                    style={{
                                        color: "#F5222D",
                                    }}>
                                    Delete
                                </Text>
                            </Menu.Item>
                        </Menu>
                    }>
                    <Icon
                        type='more'
                        onClick={(e) => {
                            // e.stopPropagation();
                        }}
                        style={{ float: "left", fontSize: "14px", paddingTop: "5px", color: "#747474" }}
                    />
                </Dropdown>
            </Col>
        </Row>
    );
};
const ListHeader = () => {
    return (
        <Row
            style={{
                marginBottom: "8px",
                padding: "8px 0px 8px 52px",
                borderRadius: "5px",
                border: "1px solid #F2F2F2",
                backgroundColor: "#F2F2F2",
            }}>
            <Col span={5}>
                <Text className='header-text'>API Name</Text>
            </Col>
            <Col span={12}>
                <Text className='header-text' style={{ paddingLeft: "5px" }}>
                    Error Message
                </Text>
            </Col>
            <Col span={7}>
                <Text
                    className='header-text'
                    style={{ paddingLeft: "30px" }}
                    // style={{marginLeft: '20px'}}
                >
                    Last Error Time
                </Text>
            </Col>
        </Row>
    );
};

const ErrorLog = (props) => {
    const [loading, setLoading] = useState(true);
    const [errorList, setErrorList] = useState(null);
    const [searchKey, setSearchKey] = useState("");

    const FetchErrorLogAPI = (SearchKey) => {
        fetchErrorLog({
            requestData: {
                search_key: SearchKey,
            },
            resCallback: () => {
                setLoading(false);
            },
            res200Callback: (res) => {
                setErrorList(res.data.error_logs);
            },
        });
    };

    useEffect(() => {
        FetchErrorLogAPI(searchKey);
    }, [searchKey]);

    return loading ? (
        <Row type='flex' align='middle' justify='center' style={{ marginTop: "200px" }}>
            <Loader />
        </Row>
    ) : (
        <Row
            style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "40px 25px 70px",
                margin: "60px auto 20px",
                backgroundColor: "#FAFAFA",
                marginTop: "80px",
            }}
            gutter={[12, 48]}>
            <Row
                type='flex'
                align='middle'
                justify='space-between'
                style={{
                    marginBottom: "24px",
                }}>
                <Text
                    style={{
                        color: "#181818",
                        /*fontFamily: "Gotham",*/ fontStyle: "normal",
                        fontWeight: "bold",
                        fontSize: "24px",
                        lineHeight: "39px",
                    }}>
                    Error Logs
                </Text>
                <div style={{ display: "flex" }}>
                    <Input
                        style={{
                            width: "275px",
                            border: "1px solid rgb(0, 0, 0, 0.25)",
                            borderRadius: "5px",
                            alignItems: "left",
                            marginRight: "14px",
                        }}
                        value={searchKey}
                        placeholder={`Search Error`}
                        onChange={(e) => {
                            setSearchKey(e.target.value);
                        }}
                        prefix={<Icon type='search' />}
                    />
                    <Button
                        onClick={(e) => {
                            resetErrorLog({
                                requestData: {
                                    error_logs: errorList.map((item)=>item.uuid),
                                },
                                resCallback: () => {},
                                res200Callback: (res) => {
                                    message.success("All Error logs is Successfully Reseted");
                                    FetchErrorLogAPI();
                                },
                            });
                        }}
                        style={{
                            alignItems: "center",
                            padding: "8px 16px",
                            color: "#FFFFFF",
                            fontSize: "16px",
                            lineHeight: "24px",
                            background: "#fec708",
                            borderRadius: "5px",
                            height: "100%",
                            marginRight: "14px",
                        }}>
                        <Icon
                            type='undo'
                            style={{
                                height: "16px",
                            }}
                        />
                        Reset All
                    </Button>
                    <Button
                        onClick={() => {
                            deleteErrorLog({
                                requestData: {
                                    error_logs: errorList.map((item)=>item.uuid),
                                },
                                resCallback: () => {},
                                res200Callback: (res) => {
                                    message.success("All Error logs is Successfully Deleted");
                                    FetchErrorLogAPI();
                                },
                            });
                        }}
                        style={{
                            alignItems: "center",
                            padding: "8px 16px",
                            color: "#FFFFFF",
                            fontSize: "16px",
                            lineHeight: "24px",
                            background: "#fec708",
                            borderRadius: "5px",
                            height: "100%",
                        }}>
                        <Icon
                            type='delete'
                            style={{
                                height: "16px",
                            }}
                        />
                        Delete All
                    </Button>
                </div>
            </Row>
            <ErrorLogTable {...props} errorList={errorList} FetchErrorLogAPI={FetchErrorLogAPI} />
        </Row>
    );
};

export default ErrorLog;
